import { render } from "./KitchenOrderDetailsItemRow.vue?vue&type=template&id=5da0cc56"
import script from "./KitchenOrderDetailsItemRow.vue?vue&type=script&lang=js"
export * from "./KitchenOrderDetailsItemRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__